import { createRequestActionTypes, createActionType } from '../../helpers'

export const FETCH_CONTACT_OPTIONS = createRequestActionTypes(
  'CONTACT_OPTIONS',
  'CONTACT_OPTIONS'
)
export const UPDATE_DISPLAY_COMPONENT = createActionType(
  'CONTACT_OPTIONS',
  'UPDATE_DISPLAY_COMPONENT'
)



// WEBPACK FOOTER //
// ./src/containers/ContactUsModal/constants.js